module.exports = __webpack_public_path__ + "static/UrbanPiper-231878ba97e3ba084e4fb335597a7f8a.jpg";